import Usuario from './Usuario'

export default Usuario